import { Validator, AbstractControl, NG_VALIDATORS } from "@angular/forms";
import { Directive, Input } from "@angular/core";

@Directive({
  selector: "[appThreeDigitsDecimalMax10orTripleDigits]",
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: ThreeDigitsDecimalMax10orTripleDigitsValidatorDirective,
      multi: true,
    },
  ],
})
export class ThreeDigitsDecimalMax10orTripleDigitsValidatorDirective
  implements Validator
{
  @Input("appThreeDigitsDecimalMax10orTripleDigits")
  appThreeDigitsDecimalMax10orTripleDigits: string;

  validate(control: AbstractControl): { [key: string]: any } | null {
    if (!this.appThreeDigitsDecimalMax10orTripleDigits) {
      return null;
    }
    if (control.value == null || isNaN(control.value)) {
      return { nan: true, valid: false };
    }
    if (
      (control.value >= 0 && control.value < 10) ||
      ["777", "888", "999"].includes(control.value)
    ) {
      return null;
    } else {
      return { outofrange: true, valid: false };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/validators/three-digits-decimal-max-10-or-triple-digits.validator.ts